var swipeActionsEdges = [
  "leading",
  "trailing"
];
var viewThatFitsAxes = [
  "horizontal",
  "vertical",
  "both"
];
export {
  swipeActionsEdges,
  viewThatFitsAxes
};
//# sourceMappingURL=groupTypes.js.map
